import ApiRequest from '../util/ApiRequest'

export default class MemberCard {
    static getMyMostRecentMemberCard = async () => {
        return await ApiRequest.set('v1/member_card/get_my_most_recent_by_member_id',"GET");
    }
}
